function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M31.983 16a3.213 3.213 0 00-1.085-2.4L15.993.481a1.92 1.92 0 00-2.533 2.882l11.516 10.133a.334.334 0 01-.22.583H1.937a1.92 1.92 0 000 3.84h22.815a.334.334 0 01.22.584L13.456 28.636a1.92 1.92 0 102.533 2.881l14.908-13.119a3.213 3.213 0 001.087-2.4z"
});

function SvgArrowRight1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgArrowRight1;